import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorType } from 'src/app/core/routing/error-types';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { IAdaptorService } from 'src/app/base/shared/syncfusion/adaptor-service.interface';
import { ToastService } from 'src/app/base/services/toast.service';
import {
  FilterDTO,
  IPagedResultDTOOfVehicleListDTO,
  SortDirection,
  VehicleClient,
} from 'src/app/base/models/models.swagger.generated';

/**
 * Vehicles are read-only here — they are created and updated only by device ingestion
 * (`VehicleController.Metadata`). This service only ever searches them; assignment of a sampling
 * profile goes through `SamplingProfilesService.assignProfileToVehicle`.
 */
@Injectable()
export class VehiclesService extends ShowInactiveService implements IAdaptorService {

  constructor(
    private vehicleClient: VehicleClient,
    private toastService: ToastService,
  ) {
    super();
  }

  public getData(
    skip: number,
    take: number,
    filters: FilterDTO[],
    sortBy: string | undefined,
    sortDirection: SortDirection | undefined,
  ): Observable<IPagedResultDTOOfVehicleListDTO | null> {
    return this.vehicleClient.searchVehicles(filters, skip, take, sortBy, sortDirection)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', '', ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }

  public addRecord(): Observable<any> {
    return throwError(() => new Error('Not supported: vehicles are read-only.'));
  }

  public updateRecord(): Observable<any> {
    return throwError(() => new Error('Not supported: vehicles are read-only.'));
  }

  public deleteRecord(): Observable<any> {
    return throwError(() => new Error('Not supported: vehicles are read-only.'));
  }
}
